<template>
  <div class="blind-box-button" :style="{ backgroundColor: backgroundColor, color: textColor }" @click="$emit('click')">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: '#FF014A',
    },
    textColor: {
      type: String,
      default: '#ffffff',
    },
  },
};
</script>
<style lang="scss" scoped>
.blind-box-button {
  padding: 15px 35px;
  font-size: 40px;
  border-radius: 42px;
  text-align: center;
  font-weight: 900;
}
</style>
